<template>
  <div class="app-consent-wrapper">
    <slot name="txtBefore">
      <p>Datenschutz & Einwilligungen</p>
    </slot>

    <ChangeConsentWrapper v-if="showChange" :nextStep="successStepName" :filter-consent-texts="consentTexts" :filter-consents="consents">
      <template v-for="slot in possibleChildSlotsFor('ChangeConsent')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ChangeConsentWrapper>

    <Success v-if="showSuccess"
    @done="backToChange">
      <template v-for="slot in possibleChildSlotsFor('Success')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Success>

    <slot name="txtAfter"></slot>
  </div>
</template>
<script>

import ChangeConsentWrapper, { stepName as changeStepName } from './ChangeConsentWrapper.vue'
import Success, { stepName as successStepName } from '../../../generic/Success.vue'
import extraData from '../../../../mixins/extraData'
import slotProxy from '../../../../mixins/slotProxy'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'ConsentWrapper',
  components: { Success, ChangeConsentWrapper },
  methods: {
    ...mapMutations('consent', [
      'changeStep'
    ]),
    backToChange () {
      this.changeStep(changeStepName)
    }
  },
  computed: {
    ...mapGetters('consent', [
      'getStep'
    ]),
    showChange () {
      return this.currentStep === changeStepName
    },
    showSuccess () {
      return this.currentStep === successStepName
    },
    successStepName () {
      return successStepName
    },
    currentStep () {
      return this.getStep
    },
    consentTexts: function () {
      return this.extraData?.consentTexts || []
    },
    consents: function () {
      return this.extraData?.consents || []
    }
  },
  mixins: [
    extraData(),
    slotProxy()
  ]
}
</script>
